import { ExpressionType } from '../ExpressionType';
import createBinaryExpression from './createBinaryExpression';
export default function createAndAlso(left, right) {
    return createBinaryExpression(ExpressionType.AndAlso, left, right);
}
